import { Component, ViewChild, inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SelectedCustomer, UserSelectors } from '@next/core-lib/user';
import { Actions } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  OfferOverviewModel,
  OffersColumnTypes,
} from 'src/app/dashboard/components/overview/models/overview.model';

import { AdvertisementsClosedDealsOffersDataSource } from 'src/app/my-advertisements/datasources/closed-deals-offers-datasource/closed-deals-offer.datasource';

@Component({
  selector: 'app-closed-deals-offers-overview',
  templateUrl: './closed-deals-offers-overview.component.html',
  styleUrls: ['./closed-deals-offers-overview.component.scss'],
  standalone: false,
})
export class ClosedDealsOffersOverviewComponent {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);

  readonly dataSource = new AdvertisementsClosedDealsOffersDataSource(this.store, this.actions$);
  readonly displayColumns = [
    OffersColumnTypes.manureCategory,
    OffersColumnTypes.manureType,
    OffersColumnTypes.amountInTons,
    OffersColumnTypes.nKgPerTon,
    OffersColumnTypes.maxNitrogen,
    OffersColumnTypes.pKgPerTon,
    OffersColumnTypes.maxPhosphate,
    OffersColumnTypes.kKgPerTon,
    OffersColumnTypes.isHomogeneous,
    OffersColumnTypes.maxDistance,
    OffersColumnTypes.desiredDeliveryPeriod,
    OffersColumnTypes.paymentType,
    OffersColumnTypes.pricePerTon,
    OffersColumnTypes.totalPrice,
    OffersColumnTypes.status,
  ];

  selectedCustomer$: Observable<SelectedCustomer> = this.store.pipe(
    select(UserSelectors.selectCustomer),
  );

  @ViewChild(MatTableDataSource) tableDataSource: MatTableDataSource<OfferOverviewModel[]>;
}
